<template>
  <van-tabbar v-model="active" inactive-color="#7d7e80" active-color="black">
    <van-tabbar-item v-for="(item,index) in tabbars" :key="index" :to="(item.name)">
      <span>{{item.title}}</span>
      <img slot="icon" slot-scope="props" :src="props.active? item.active : item.normal" />
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  name: "tabbar",

  data() {
    return {
      active: 0,
      tabbars: [
        {
          name: "/",
          title: "胖虎首页",
          normal:
            require('@/assets/picture/1.1.png'),
          active:
            require('@/assets/picture/1.png'),
        },
        {
          name: "/user",
          title: "个人中心",
          normal:
            require('@/assets/picture/2.1.svg'),
          active:
            require('@/assets/picture/2.svg'),
        }
      ]
    };
  },
  methods: {},
  //通过路由跳转判断选中的样式
  created() {
    console.log(this.$route.name );
    if (this.$route.name == "index") {
      this.active = 0;
    } else if (this.$route.name == "user") {
      this.active = 1;
    } else if(this.$route.name == "airecycle") {
      this.active = '';
    }
  }
};
</script>

<style lang="less" >
.van-tabbar-item{
  .van-tabbar-item__icon{
    margin-left: -3px;
    img{
      display: block;
      width: 24px;
      height: 24px;
      margin-top: 2px;
    }
  }
  .van-tabbar-item__text{
    
  }
}
.van-tabbar-item:nth-child(1):before{
  content: "";
  width: 1px;
  height: 15px;
  background:rgba(229,229,229,1);
  position: absolute;
  right: 50%;
  .van-tabbar-item__text{
    margin-left: 5px;
  }
}
</style>

